import ScrollAction from 'lib/scroll-action';


/**
 * Video Scroll Action
 *
 * Extended from general scroll action class. To add functionality to play a
 * video over the course of one screen scroll
 */
export default class VideoScrollAction extends ScrollAction {

    /**
     * constructor
     *
     * @param  {Element} element
     */
    constructor (element) {
        super(element, {
            hijackMode: false
        });

        this.canvas = this.element;

        this.source = this.canvas.dataset.source;
        this.frames = this.canvas.dataset.frames - 1;
        this.horizontalFrames = this.canvas.dataset.framesX;
        this.verticalFrames = this.canvas.dataset.framesY;

        this.currentFrame = 1;

        if (!this.canvas) {
            console.warn('No video found in VideoScrollAction');
        }

        this.getContext();
        this.loadImage();
    }

    /**
     * getContext
     * Gets canvas context
     */
    getContext () {
        this.context = this.canvas.getContext('2d');
    }

    /**
     * Start loading the sprite image
     */
    loadImage () {
        this.image = document.createElement('img');
        this.image.addEventListener('load', this.imageLoaded.bind(this), false);
        this.image.setAttribute('src', this.source);
    }

    /**
     * imageLoaded
     * Called when image finished loading
     */
    imageLoaded () {
        this.calcFrameDimentions();
        this.setFrame(0);
    }

    /**
     * calcFrameDimentions - description
     *
     * @return {type}  description
     */
    calcFrameDimentions () {
        let width, height;

        width = this.image.naturalWidth;
        height = this.image.naturalHeight;

        this.frameWidth = width / this.horizontalFrames;
        this.frameHeight = height / this.verticalFrames;

        this.canvas.width = this.frameWidth;
        this.canvas.height = this.frameHeight;
    }

    /**
     * setFrame
     *
     * Row and column lets, are just like arrays, the first row or col is 0
     *
     * @param  {Number} frame
     */
    setFrame (frame) {
        let row, column;

        row = Math.floor((frame) / this.horizontalFrames);
        column = (frame) % this.horizontalFrames;

        window.requestAnimationFrame(() => {
            this.context.drawImage(
                this.image,
                column * this.frameWidth,
                row * this.frameHeight,
                this.frameWidth,
                this.frameHeight,
                0,
                0,
                this.canvas.width,
                this.canvas.height
            );

            this.currentFrame = frame;
        });
    }

    /**
     * animationCallbacker
     *
     * Called on scroll, returns a number between 0.00 and 1.00, indicating
     * how far the scroll action is
     *
     * @param  {Number} animationPercentage
     */
    animationCallback (animationPercentage) {
        let frame = Math.round(this.frames * animationPercentage);

        if (frame !== this.currentFrame) {
            this.setFrame(frame);
        }
    }
}



// WEBPACK FOOTER //
// ./lib/video-scroll-action.js